import React from 'react';
import withAppState from '../../../mobx/withAppState'
import { Steps } from '../../../lib/constants';
import RestaurantSearch from '../../../components/RestaurantSearch';

const MiPayAtTableRestaurantSearchWrapper = props => {
  const handleRestaurantSelect = (restaurant) => {
    props.selectRestaurant(restaurant);
    props.goToStep(Steps.TABLE_PICKER);
  }

  return <RestaurantSearch handleRestaurantSelect={handleRestaurantSelect} />
}

export default withAppState(MiPayAtTableRestaurantSearchWrapper,
  {
    mobXActions: ({
      selectRestaurant,
      goToStep,
    }) => ({
      selectRestaurant,
      goToStep,
    })
  }
);